const couponsDictIT = {
  specialCustomerRegisterCoupons: "Buoni di Credito",
  generateCoupon: "Coupon di invito",
  extracoinAmount: "Valore del credito Extracredit",
  unexpectedErrorWhileGeneratingCoupon:
    "Errore imprevisto durante la generazione del coupon di credito.",
  currency: "Moneta",
  used: "Usato",
  notUsed: "Non usato",
  couponGenerated: "Hai generato con successo un nuovo coupon di credito!",
  canceledCoupon: "Hai annullato l'operazione per generare un nuovo coupon di credito",
  areYouSureCoupon:
    "Sei sicuro di voler generare un nuovo coupon di credito? Il valore verrà addebitato sul tuo saldo Extracredit.",
  confirmYourAction: "Conferma la tua azione",
  confirm: "Confermare",
  usedBy: "Usato da",
  generatedCoupon: "Coupon generato",
  inviteCouponDialogTitle: "Creazione del coupon invito",
  inviteCouponDialogSubtitle: "Invia crediti extra di benvenuto.",
  inviteCouponSectionBalance: "Saldo crediti extra",
  inviteCouponSectionData: "Dati del coupon",
  inviteCouponAmountLabel: "Inserisci l'importo",
  inviteCouponAmountTooltip: "Importo addebitato sul tuo saldo Extracredit alla creazione del coupon.",
  inviteCouponAmountHint: "Usa fino a {balance} ECR",
  inviteCouponBelowMinBalance: "Il saldo minimo per creare un coupon è {min} ECR.",
  inviteCouponCreating: "Attendere mentre creiamo il coupon.",
  inviteCouponCancel: "Annulla",
  inviteCouponCreate: "Crea coupon",
  inviteCouponSuccessTitle: "Coupon creato",
  inviteCouponSuccessMeta: "Successo • {dateTime}",
  inviteCouponYouUsed: "Hai usato",
  inviteCouponCodeSection: "Codice del coupon",
  inviteCouponShareHint:
    "Condividi questo codice con il tuo invitato. Riceverà {couponValue} in ECR non appena si registrerà. Questo codice può essere usato una sola volta.",
  inviteCouponFinish: "Concludi",
  inviteCouponErrorGeneric: "Impossibile creare il coupon. Riprova.",
};

export default couponsDictIT;
